import './ChatThread.css'

import { cx } from '../utilities/cx'
import { ScrollArea } from './ScrollArea'

export type ChatThreadProps = {
  className?: string
  children: React.ReactNode
}

export const ChatThread = (props: ChatThreadProps) => {
  const { className, children } = props

  return (
    <div className={cx('chat-thread', className)}>
      <ScrollArea vertical fitParent scroll={{ vertical: 'bottom' }}>
        <div className="chat-thread__content">{children}</div>
      </ScrollArea>
    </div>
  )
}
